import React from "react";
import APILink from "./ApiLink";
import "./Component.css";
import MenuAccordionComponent from "./MenuAccordionComponent";
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card';
import Footer from "./Footer";

import logo from  "../components/Myntra_Footer.png";
import { ChevronDown, Youtube, Instagram, Twitter, Linkedin, Facebook} from 'react-bootstrap-icons';

const Sidebar = (props) => {
  let organizationName = props.organizationName;
  var infocards = [];

  const teamMap = new Map();
  const teamNameMap = new Map();
  if(props.definitionList != null){
      for(let i = 0; i < props.definitionList.length; i++){

          let openapiFileName = props.definitionList[i].openapi_json;
          let isOnboarded = openapiFileName.localeCompare("20210412-112406-Sample_SwaggerOpenApi.json");

          let team_id = props.definitionList[i].team_id;
          if(!teamMap.has(team_id)){
              teamMap.set(team_id, []);
              teamNameMap.set(team_id, props.definitionList[i].team_name);
          }
          let apiLink = (<APILink
              key={i}
              apiLinkData={props.definitionList[i]}
              updateDefinitionLink={props.updateDefinitionLink}
          />);

          if(isOnboarded!==0)
            teamMap.set(team_id, [...teamMap.get(team_id), apiLink]);
      }
  }

  return (
    <div>
    <div className="side-bar">
      <div className="side-bar-header">
      </div>
      <div className="side-bar-body">
        <div style={{paddingLeft: "10px", paddingTop: "0px"}}></div>
          <MenuAccordionComponent teamMap={teamMap} internal={props.internal} teamNameMap={teamNameMap} definitionList={props.definitionList} updateDefinitionLink = {props.updateDefinitionLink}/>
      </div>
      <div className="footer">
        <Footer
          updateModalStatesPP={props.updateModalStatesPP}
        />
      </div>
    </div>
    </div>

  );
};

export default Sidebar;
